export { Title } from '@mantine/core'
export type { TitleProps } from '@mantine/core'